export default __webpack_public_path__ + "static/media/img4.eacd4276.png";